import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "text-success" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-2" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger small"
}

import Api from "@/services/api"
    import { Withdraw } from "@/services/types/affiliate";
    import { ElDivider, ElMessage, FormInstance, FormRules } from "element-plus"
    import { reactive, ref } from "vue"

    
export default /*@__PURE__*/_defineComponent({
  __name: 'WithdrawView',
  props: {
    withdraw: {}
  },
  emits: ["update"],
  setup(__props: any, { emit: __emit }) {

    const props = __props
    const transaction_id = ref<string>('')

    // eslint-disable-next-line no-undef
    const emit = __emit

    const saving = ref<boolean>(false)
    const loading = ref<boolean>(false)
    const error = ref<string | null>(null)

    const validate = () => {
        if (!transaction_id.value || transaction_id.value.trim().length <= 0) {
            error.value = 'Preencha o id da transacao'
            return;
        }

        error.value = null
    }
    const submit = async () => {
        if (!transaction_id.value || transaction_id.value.trim().length <= 0) {
            error.value = 'Preencha o id da transacao'
            return;
        }
        saving.value = true
        
        const res = await Api.post('admin/affiliates/deposit/' + props.withdraw.id, {transaction_id: transaction_id.value})
        console.log(res.data)
        if (res.status == 200) {
            ElMessage.success({message: 'Marcado como pago'})
            emit("update", res.data.withdraw)
        } else if (res.status == 422) {
            if (res.data.errors) {
                for(let err in res.data.errors) {
                    ElMessage.error({message: res.data.errors[err].join(', ')})
                }
            }
        } else {
            ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
        }
        saving.value = false
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createBlock(_component_el_skeleton, {
    rows: 12,
    loading: loading.value,
    animated: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _cache[1] || (_cache[1] = _createTextVNode(" Afiliado: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(__props.withdraw.affiliate?.user.name), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[2] || (_cache[2] = _createTextVNode(" Data do pedido: ", -1)),
          _createElementVNode("strong", null, _toDisplayString(new Date(__props.withdraw.created_at ?? 0).toLocaleString()), 1)
        ]),
        _createElementVNode("div", null, [
          _cache[3] || (_cache[3] = _createTextVNode(" Valor solicitado: ", -1)),
          _createElementVNode("strong", _hoisted_2, _toDisplayString(__props.withdraw.value.toFixed(2)) + "MT", 1)
        ]),
        _createElementVNode("div", null, [
          _cache[4] || (_cache[4] = _createTextVNode(" Conta a enviar: ", -1)),
          _createElementVNode("strong", _hoisted_3, _toDisplayString(__props.withdraw.account), 1)
        ]),
        (__props.withdraw.transaction_id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[5] || (_cache[5] = _createTextVNode(" ID transação: ", -1)),
              _createElementVNode("strong", null, _toDisplayString(__props.withdraw.transaction_id) + "MT", 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", {
            style: {"border-radius":"10px","display":"inline-block"},
            class: _normalizeClass(["p-3 py-1 text-light", {'bg-success': __props.withdraw.sent, 'bg-danger': !__props.withdraw.sent}])
          }, _toDisplayString(__props.withdraw.sent ? 'Enviado':'Pendente'), 3)
        ])
      ]),
      (!__props.withdraw.sent)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(ElDivider)),
            _createVNode(_component_el_form, {
              ref: "formRef",
              disabled: saving.value,
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  prop: "title",
                  label: "ID da transacao"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      name: "title",
                      type: "text",
                      modelValue: transaction_id.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((transaction_id).value = $event)),
                      onKeypress: validate
                    }, null, 8, ["modelValue"]),
                    (error.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(error.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  plain: "",
                  loading: saving.value,
                  size: "large",
                  type: "success",
                  onClick: _withModifiers(submit, ["prevent"])
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Marcar como pago ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            }, 8, ["disabled"])
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})